module.exports = __webpack_public_path__ + "img/icon-edit.cb29dd8c.svg";